<template>
  <v-snackbar
      :timeout="-1"
      v-model="$store.state.successSnackbarOpen"
      color="green"
      rounded="pill"
      top
      class="mt-12"
      min-width="150"
  >
    {{ this.$store.state.successMessage }}
  </v-snackbar>
</template>

<script>
export default {
  name: 'success-snackbar',
}
</script>

<style>
.v-snack__content {
  display: flex;
  justify-content: center;
  margin-left: 8px;
}
</style>
